import { render, staticRenderFns } from "./take-tongue-three.vue?vue&type=template&id=60b13df8&scoped=true"
import script from "./take-tongue-three.vue?vue&type=script&lang=ts"
export * from "./take-tongue-three.vue?vue&type=script&lang=ts"
import style0 from "./take-tongue-three.vue?vue&type=style&index=0&id=60b13df8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b13df8",
  null
  
)

export default component.exports